
import React from 'react';
import ReactDOM from 'react-dom';
import AppBanner from '/home/circleci/app/components/AppBanner';

const element = typeof document !== 'undefined' && document.querySelector('#AppBanner');

if (element) {
    const props = window.initialData['AppBanner'];

    ReactDOM.render(
        <AppBanner {...props}/>,
        element
    );
}

export default AppBanner;
